<template>
  <div>
    <div>
      <search-bar></search-bar>
    </div>
    <v-container v-if="secFound && isFound">
      <school-info :info="secDt.info"></school-info>
      <v-layout>
        <v-flex>
        <v-stepper class="mt-3" v-model="e4" vertical>

          <last-rec :datevalue="secDt.lastRev" 
            labelText="* ថ្ងៃ ខែ ឆ្នាំចុងក្រោយដែលទទួលបានសៀវភៅសិក្សាគោលពីក្រសួងអប់រំយុវជននិងកីឡា៖ "
          >
          </last-rec> 
          
          <div id="page1"></div>
          <v-stepper-step editable step="1">
            <big class="mainTitle">{{mTitle[0]}}</big>
          </v-stepper-step>
          <v-stepper-content step="1">          
            <sec-basic-info :tstudent="secDt.tStu" :extradata="secDt.edata"></sec-basic-info>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page2');e4 = 2">ទៅកាន់ ២</v-btn>
          </v-stepper-content>

          <div id="page2"></div>
          <v-stepper-step editable step="2">
            <big class="mainTitle">{{mTitle[1]}}{{getAcc.curAcc}}</big>
          </v-stepper-step>
          <v-stepper-content step="2">
            <sec-table-group :fTitle="sTitle[0]" :fData="secDt.t1" :sTitle="sTitle[1]" :sData="secDt.t2"></sec-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page3');e4 = 3">ទៅកាន់ ៣.ក</v-btn>
          </v-stepper-content>

          <div id="page3"></div>
          <v-stepper-step editable step="3">
            <big class="mainTitle">{{mTitle[2]}}<br>{{mTitle[3]}}({{getAcc.lstAcc}})</big>
          </v-stepper-step>
          <v-stepper-content step="3">
            <sec-table-group :fTitle="sTitle[2]" :fData="secDt.t3" :sTitle="sTitle[3]" :sData="secDt.t4"></sec-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page4');e4 = 4">ទៅកាន់ ៣.ខ</v-btn>
          </v-stepper-content>

          <div id="page4"></div>
          <v-stepper-step editable step="4">
            <big class="mainTitle">{{mTitle[4]}}{{getAcc.curAcc}}</big>
          </v-stepper-step>
          <v-stepper-content step="4">
            <sec-table-group :fTitle="sTitle[4]" :fData="secDt.t5" :sTitle="sTitle[5]" :sData="secDt.t6"></sec-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page1');e4 = 1">ទៅកាន់ ១</v-btn>
          </v-stepper-content>
          
        </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-if="isFound && secFound">
      <navigation-bar></navigation-bar>
    </div>
  </div>
</template>

<script>
import apCon from '@/utils/textbookConfig.js'
const SearchBar = () => import('@/components/common/SearchBar.vue')
const schoolInfo = () => import('@/components/common/SchoolInfo.vue')
const lastRe = () => import('@/components/common/dateinput.vue')
const secBasicInfo = () => import('@/components/textbook/secondaryBasicInfo.vue')
const secTableGroup = () => import('@/components/textbook/secondaryTableGroup.vue')
const NavigationBar = () => import('@/components/common/NavigationBar.vue')

export default {
  components: {
    'searchBar': SearchBar,
    'school-info': schoolInfo,
    'sec-basic-info': secBasicInfo,
    'last-rec': lastRe,
    'sec-table-group': secTableGroup,
    'navigationBar': NavigationBar
  },
  data () {
    return {
      e4: 1,
      isFound: false,
      sTitle: apCon.tbSubTitle,
      mTitle: apCon.tbMainTitle
    }
  },
  computed: {
    getAcc: function () {
      return {
        curAcc: this.$store.state.uiControl.cur_acc_text,
        lstAcc: this.$store.state.uiControl.lst_acc_text
      }
    },
    secFound: function () {
      if (this.$store.state.textbook.school_dt_sec.res === '1') {
        this.isFound = true
        this.e4 = 1
        // set the schoolState to the UI store for enable/disable SAVE Button
        this.$store.dispatch('uiControl/setSchoolState', this.$store.state.textbook.school_dt_sec.state_code.sta_code)
        return true
      }
    },
    secDt: function () {
      return {
        info: this.$store.state.textbook.school_dt_sec,
        edata: this.$store.state.textbook.school_dt_sec.extra,
        tStu: this.$store.state.textbook.school_dt_sec.stu_by_grade,
        lastRev: this.$store.state.textbook.school_dt_sec.date_rec,
        t1: this.$store.state.textbook.school_dt_sec.textbook_t1,
        t2: this.$store.state.textbook.school_dt_sec.textbook_t2,
        t3: this.$store.state.textbook.school_dt_sec.textbook_t3,
        t4: this.$store.state.textbook.school_dt_sec.textbook_t4,
        t5: this.$store.state.textbook.school_dt_sec.textbook_t5,
        t6: this.$store.state.textbook.school_dt_sec.textbook_t6
      }
    }
  },
  created () {
    this.$store.dispatch('textbook/loadDefaultTextbookSec')
    this.$store.dispatch('uiControl/setEnableSave')
  }
}
</script>

<style scoped>
  .mainTitle {
    font-weight: bold;
    font-family: "khmer OS";
    font-size: 14px;
  }
  .sttext {
  font-family: "khmer OS";
  font-size: 12px;
}

</style>